import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { ReportPropertyDetailService } from '../../residential-property/residential-property-detail.service';
import { ReportPropertyDetailConstant } from '../../residential-property/residential-property-detail.constant';
import { SharedService } from 'src/app/common/services/shared.service';

@Component({
  selector: 'app-residential-units',
  templateUrl: './residential-units.component.html',
  styleUrls: ['./residential-units.component.scss']
})
export class ResidentialUnitsComponent implements OnChanges {
  @Output() isEmpatyCheck:any = new EventEmitter();
  @Input() propertyInfo: any;
  residentialUnitsLoading = false;
  residentialUnitsCount = 0;
  residentialDataCount = 0;
  residentialUnitsData = [];
  residentialColumns  = ReportPropertyDetailConstant.residentialColumns;

  constructor(public reportPropertyDetailService: ReportPropertyDetailService,
    private sharedService : SharedService
  ){}

  ngOnChanges(): void {
     this.reportPropertyDetailService.propertyInfo = this.propertyInfo;
    this.sharedService.language$.subscribe({
      next : (res: any) => {
        this.getUnit();
      },
      error : (err:any) => { }
    })
  }


  getUnit() {
    this.residentialUnitsLoading = true;
    this.reportPropertyDetailService.getUnitReport(this.reportPropertyDetailService.unitPayload).subscribe(
      {
        next: (res: any) => {
          if (res.status === 200) {
           this.residentialUnitsData = res.data;
            this.isEmpatyCheck.emit(false);
            if(this.reportPropertyDetailService.unitPayload.pageNumber == 0){
            this.residentialUnitsCount = res.total_units_count;
            this.residentialDataCount = res.count;
           }

          } else {
            this.isEmpatyCheck.emit(true);
            this.residentialUnitsData = [];
            this.residentialUnitsCount = 0;
            this.residentialDataCount = 0;
          }
          this.residentialUnitsLoading = false;
        },
        error:()=>{
           this.isEmpatyCheck.emit(true);
          this.residentialUnitsLoading = false;
          this.residentialUnitsData = [];
          this.residentialUnitsCount = 0;
          this.residentialDataCount = 0;
        }
      }
    )
  }



  onPageEvent(e: any) {
    this.reportPropertyDetailService.unitPayload.pageNumber = (e.pageSize * e.pageIndex);
    this.getUnit();
  }

  sortData(event: any) {
    let sort = {
      column: event.active,
      order: event.direction
    }
    this.reportPropertyDetailService.unitPayload.pageNumber = 0;
    this.reportPropertyDetailService.unitPayload.sort_order = JSON.stringify(sort).replace(/[+]/g, '%2B');
    this.getUnit();
  }

  downloadExcel(event: any, type: string) {
    this.reportPropertyDetailService.downloadRentalReport(type,'residential', this.propertyInfo.property_uid, 'a');
  }



}
